import React from 'react'

const sources = [
  { source_name: "LinkedIn", logo: "LinkedIn", percent: "46%" },
  { source_name: "UpWork", logo: "UpWork", percent: "31%" },
  { source_name: "Indeed", logo: "Indeed", percent: "23%" },
  { source_name: "Handshake", logo: "Handshake", percent: "16%" },
]


const CandidateBySource = () => {
  return (
   <div>
    <div className="flex space-between" style={{ textAlign: "center", marginBottom: "40px", fontSize: "12px", fontWeight: "normal" }}>
            <span>Candidates by source</span>
            <span className='secondary-color'>See all leads</span>
    </div>
    {
        sources.map( (source, index) =>(
            
        <div className='flex space-between' style={{marginBottom:"15px"}}>
            <div className='item flex item-center'>

                <img style={{marginRight:"15px", verticalAlign:"middle"}} src={require(`../assets/JobSources/${source.logo.toLowerCase().replace(/\s+/g, "-")}-logo.png`)} alt="" />
                <span className='font-size-14px' style={{color:"#54595F"}}>{source.source_name}</span>
            </div>
            <div className='item'>
                <span style={{color:"#29ABFF", fontSize:"14px" }}>{source.percent}</span>
            </div>
        </div>
        )
    )
    }
   </div>
  )
}

export default CandidateBySource